import { component } from "picoapp";

export default component((node) => {
  // handle image hover features...
});
